import styled from "styled-components";
import media from "constants/media";

import { ButtonLinkStyled } from "components/shared/button/Button.styled";

export const ExtraInfoStyled = styled.div`
    padding: 25px 20px;

    background-color: var(--color-athensGrey);

    ${media.mdUp`
        border-bottom-right-radius: 30px;
        border-bottom-left-radius: 30px;
    `};
`;

export const Text = styled.p`
    color: var(--color-darkNight);
    font-size: 12px;
    line-height: 20px;
    text-align: center;

    ${ButtonLinkStyled} {
        padding-bottom: 0;

        font-size: 12px;
        line-height: 12px;

        ${media.mdUp`
            padding-bottom: 3px;
            line-height: 20px;
        `};
    }
`;
